import React, { useRef, useState } from 'react'
// import { motion } from "motion/react";
import { motion } from "framer-motion";
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../reducers/store';
import { ImageBuffer, ToggleModeButton, SubCover, Banner, Name } from '../..';
import { useScrollPosition } from '../../../utils/scrollPosition';
import { CloseRounded, KeyboardArrowDownRounded, MenuRounded } from '@mui/icons-material';
import { logo } from '../../../assets';

import './navbar.css'

const Navbar = ({theme}: any) => {
  const dispatch                                = useDispatch<AppDispatch>();
  const modalNavRef                             = useRef<HTMLDivElement | null>(null);
  const scrollPosition                          = useScrollPosition();
  const [toggleNav, setToggleNav]               = useState<boolean>(false);
  const [openSubMegaMenu, setOpenSubMegaMenu]   = useState<number | null>(null);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setToggleNav(false);
    setOpenSubMegaMenu(null);

    const element = document.getElementById(id);
    if (element) {
      // const offset = 80; // same as navbar height
      const offset = document.querySelector(".navbar")?.clientHeight || 0;
      const y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleToggleNav = () => {
    setToggleNav(prev => !prev)
  }

  const handleCloseCover = () => {
    setOpenSubMegaMenu(null)
  }

  const handleMenuBox = (index: number) => () => {
    setOpenSubMegaMenu(prev => (prev === index ? null : index));
  }

  const closeNavModal = (e: React.MouseEvent<HTMLElement>) => {
    if(modalNavRef.current === e.target){
      setToggleNav(false)
    }
  }

  const closeNavModalLink = () => {
    setToggleNav(false);
    setOpenSubMegaMenu(null);
  };

  return (
    <>
      <motion.nav 
        initial={{opacity: 0, y: -50}} 
        animate={{opacity: 1, y: 0}} 
        transition={{duration: 0.6, ease: 'easeOut'}}
        className={scrollPosition > 50 ? 'navbar active-scroll' : 'navbar'}>
        <a href="/" className='nav-logo-wrapper'>
          <div className='nav-logo'>
            {/* <ImageBuffer src={siteLogo} alt='logo' /> */}
            <ImageBuffer src={logo} alt='logo' />
          </div>
          {/* <Name /> */}
        </a>
        
        <div className='navbar-show-btn navbar-open-close' onClick={handleToggleNav}><MenuRounded /></div>

        <div className={toggleNav ? 'navbar-collapse navbar-show' : 'navbar-collapse'} ref={modalNavRef} onClick={closeNavModal}>
          <div className='navbar-collapse-inner'>
            <div className='navbar-hide-btn navbar-open-close' onClick={handleToggleNav}><CloseRounded /></div>
              <div className="navbar-nav-cover">

                <ul className="navbar-nav">
                  <li><a className='menu-link' href="/"><span>Home</span></a></li>
                  <li><a onClick={(e) => handleScroll(e, "about")} className='menu-link' href="#about"><span>About</span></a></li>
                  <li><a onClick={(e) => handleScroll(e, "services")} className='menu-link' href="#services"><span>Services</span></a></li>
                  <li className={openSubMegaMenu === 1 ? 'has-dropdown active' : 'has-dropdown'}>
                    <div className='menu-link menu-link-dropdown' onClick={handleMenuBox(1)}>
                      <span>More...</span>
                      <KeyboardArrowDownRounded />
                    </div>
                      <ul className={openSubMegaMenu === 1 ? 'sub-menu list-block active' : 'sub-menu'}>
                        {/* <li><a className='sub-menu-link' href="/login">Enroll Now</a></li> */}
                        <li><a onClick={(e) => handleScroll(e, "care")} className='sub-menu-link menu-link' href="#care"><span>Personalized Care</span></a></li>
                        <li><a onClick={(e) => handleScroll(e, "disability")} className='sub-menu-link menu-link' href="#disability"><span>Disability Services</span></a></li>
                        <li><a className='sub-menu-link menu-link' href="/enrollment"><span>Enrollment</span></a></li>
                      </ul>
                  </li>

                  <li><a onClick={(e) => handleScroll(e, "contact-us")} className='menu-link contact-us-btn' href="#contact-us"><span>Contact Us</span></a></li>
                  <li>
                    <div className='switch-wrapper'>
                      <div className="switch">
                        {/* <ToggleModeButton theme={theme} /> */}
                      </div>
                    </div>
                  </li>
                </ul>

              </div>
          </div>
        </div>
      </motion.nav>
      <Banner />

      {openSubMegaMenu !== null && (
        //z-index: 3, others should be higher
        <SubCover handleCloseCover={handleCloseCover} />
      )}
    </>
  )
}

export default Navbar